import React from "react";
// import "./Brand.css";

function Brand() {
  return (
    <div className="brand-content-container" style ={{marginTop: "-25", marginBottom :"-25px"}}>
      <a href="/">
        <img
          className="brand-responsive-image"
          src="/Images/logo150x150.webp"
          alt="logo"
        />
      </a>
      <div>
        <h5 className="brand-content-container-h5">
          {/* Jal Management : Omaxe City RWS Phase-1 */}
          Jal Management : OCRWS Ph-1
        </h5>
        <h5 className="brand-content-container-h5">
          {/* जल प्रवंधन : ओमैक्स सिटी रेसिडेंट्स वेलफेयर सोसाइटी फेज -1 */}
          जल प्रवंधन : ओ सी आर डब्लू अस फेज -1
        </h5>

        <p className="brand-content-container-p">
          An initiative of Omaxe City Residents Welfare Society ph-1       </p>
      </div>
    </div>
  );
}

export default Brand;
